import React from 'react'
import Dashboard from '../Components/Dashboard'
import MainGrid from './Components/MainGrid'

function PaymentsPage() {
  return (

    <MainGrid />
  )
}

export default PaymentsPage